

import React, { useState, useEffect } from "react";
import "./Header.css";
import logo from "../../assets/imgs/logo.png";
import homBnr from "../../assets/imgs/homBnr.jpg";
import "../../assets/css/app.css";

import ContactForm from "../ContactForm/ContactForm";   
export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  const scrollToSection = (id) => {
    closeMenu();
    const section = document.getElementById(id);
    if (section) section.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const handleScroll = () => {
      const nav = document.querySelector(".stickyNav");
      if (window.scrollY > 50) nav.classList.add("small");
      else nav.classList.remove("small");
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="headerSec" style={{ backgroundImage: `url(${homBnr})` }}>
      <div className="topGradient"></div>

      <div className="maxW">
        <div className="navBar stickyNav">
          <a href="/" className="logo">
            <img src={logo} alt="Arvind Smartspaces" />
          </a>
<button
  type="button"
  className={`hamburger ${menuOpen ? "active" : ""}`}
  onClick={() => setMenuOpen(prev => !prev)}
  aria-label="Toggle navigation menu"
  aria-expanded={menuOpen}
  aria-controls="primary-navigation"
>
            <span></span><span></span><span></span>
     </button>

<nav
  id="primary-navigation"
  className={`nav ${menuOpen ? "show" : ""}`}
  role="navigation"
>
     <ul>
  <li>
    <button
      type="button"
      className="navBtn"
      onClick={() => scrollToSection("about")}
    >
      ABOUT PROJECT
    </button>
  </li>

  <li>
    <button
      type="button"
      className="navBtn"
      onClick={() => scrollToSection("highpoints")}
    >
      HIGHPOINTS
    </button>
  </li>

  <li>
    <button
      type="button"
      className="navBtn"
      onClick={() => scrollToSection("amenities")}
    >
      AMENITIES
    </button>
  </li>

  <li>
    <button
      type="button"
      className="navBtn"
      onClick={() => scrollToSection("plotsizes")}
    >
      PLOT SIZES
    </button>
  </li>

  <li>
    <button
      type="button"
      className="navBtn"
      onClick={() => scrollToSection("location")}
    >
      LOCATION
    </button>
  </li>

  <li>
    <button
      type="button"
      className="navBtn"
      onClick={() => scrollToSection("price")}
    >
      PRICE &amp; PAYMENT
    </button>
  </li>

  <li>
    <button
      type="button"
      className="navBtn"
      onClick={() => scrollToSection("gallery")}
    >
      GALLERY
    </button>
  </li>

  <li>
    <button
      type="button"
      className="navBtn"
      onClick={() => scrollToSection("faqs")}
    >
      FAQS
    </button>
  </li>

  <li>
    <button
      type="button"
      className="navBtn"
      onClick={() => scrollToSection("contact")}
    >
      CONTACT
    </button>
  </li>
</ul>

          </nav>
        </div>

        {menuOpen && <div className="overlay" onClick={closeMenu}></div>}

        <div className="bnrHd">
          <h1>
            Arvind Smart Spaces – A premium plotted lifestyle developed for
            connection and comfort.
          </h1>
        </div>
     
 
        <div className="bnrContent">
          <ContactForm />
        </div>

      </div>
    </header>
  );
}
